import SideModal from "components/SideModal";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { editCouncilLitigation } from "services/prosecutorDecipilineService";
import { Complaints, CouncilLitigation } from "types";
import { LoadingIcon } from "utils/constant";
import "../../complaintRequest/styles/AddEvidenceModal.css";

interface FeedbackModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  litigationData: CouncilLitigation;
  complaintData: Complaints;
  onRefresh: any;
}

export default function UploadCouncilClaimFile({
  isOpen,
  setIsOpen,
  litigationData,
  complaintData,
  onRefresh,
}: FeedbackModalProps) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState<string | null>(null);
  // const [success, setSuccess] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [files, setFiles] = useState<File[]>([]);
  const [formState, setFormState] = useState<any>({
    claim_summary: "",
  });

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    setFormState((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFiles([...Array.from(e.target.files as FileList)]);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!litigationData) return;

    setLoading(true);
    // setError(null);
    // setSuccess(false);

    const data = new FormData();
    data.append("claim_summary", formState.claim_summary || "");
    data.append("claim_summary_files", files[0] || "");
    data.append("summon", litigationData?.summon || "");
    data.append("litigationId", litigationData?.id || "");

    data.append(
      "assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "user_id_assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "accused_prosecutor_name",
      complaintData?.accused_prosecutor_name || ""
    );
    data.append(
      "user_id_accused_prosecutor_name",
      complaintData?.user_id_accused_prosecutor_name || ""
    );
    data.append(
      "accused_prosecutor_org_id",
      complaintData?.accused_prosecutor_org_id || ""
    );
    data.append(
      "accused_prosecutor_admin_unit_id",
      complaintData?.accused_prosecutor_admin_unit_id || ""
    );
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");

    const litigationId = litigationData?.id || "";
    const isFormData = true;

    try {
      await editCouncilLitigation(data, litigationId, isFormData);

      onRefresh();
      setIsOpen(false);
      showToast("Successfully Created", "success");
      // setSuccess(true);
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast("Submission error", "error");
      // setError(
      // err?.response?.data?.message || err.message || "Something went wrong."
      // );
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={"Upload Claim File"}
    >
      <form onSubmit={handleSubmit} className="evidence-form">
        <section className="evidence-section">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Claim Summary
            </label>
            <textarea
              rows={3}
              name="claim_summary"
              value={formState.claim_summary}
              onChange={handleChange}
              placeholder="Details here..."
              className="w-full border bg-gray-100 rounded-md p-2 text-sm"
            />
          </div>
        </section>
        <section className="evidence-section">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Claim File
          </label>
          <div className="file-upload-area" onClick={triggerFileInput}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              // multiple
              style={{ display: "none" }}
            />
            <p className="upload-text">Upload Files</p>
            {files && files?.length > 0 && (
              <div className="file-list">
                {files?.map((file, index) => (
                  <div key={index} className="file-item">
                    {file.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>

        <button
          type="submit"
          className="bg-black w-full text-white px-6 py-2 rounded-md hover:bg-gray-800"
          disabled={loading}
        >
          {loading ? (
            <div className="flex items-center justify-center">
              {LoadingIcon}
              Submitting...
            </div>
          ) : (
            "Upload"
          )}
        </button>
      </form>
    </SideModal>
  );
}
